import React, { ChangeEventHandler, ComponentType, HTMLInputTypeAttribute } from 'react';
import { Field } from 'formik';
import { FieldProps } from 'formik/dist/Field';

const isUntrimmed = (str: string) => /^\s|\s$/.test(str);

interface BaseFormikProps {
	onChange?: ChangeEventHandler<HTMLInputElement>;
	type?: HTMLInputTypeAttribute;
	name?: string;
}
export function createFormikComponent<T extends BaseFormikProps>(
	Component: ComponentType<T>
) {
	return function wrappedFormikComponent(props: T) {
		return (
			<Field {...props}>
				{({ field, form }: FieldProps) => {
					function isInputDirty(name: string) {
						// from https://github.com/jaredpalmer/formik/issues/3612
						const boolean =
							form.getFieldMeta(name).value === form.getFieldMeta(name).initialValue;
						return !boolean;
					}
					const wrappedOnChange: ChangeEventHandler<HTMLInputElement> = (e, ...args) => {
						// All browsers will trim email inputs except Firefox.
						// Trim whitespace for browser consistency
						if (props.type === 'email' && isUntrimmed(e.target.value) && props.name) {
							return form.setFieldValue(props.name, e.target.value.trim());
						}
						if (props.onChange) props.onChange(e, ...args);

						field.onChange(e, ...args);
					};

					const error =
						(form.submitCount > 0 || isInputDirty(field.name)) && form.errors[field.name];

					return (
						<Component
							{...(props as T)}
							{...field}
							onChange={wrappedOnChange}
							error={error}
						/>
					);
				}}
			</Field>
		);
	};
}
